/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 15/11/2021
 * @Example
 */

import { types } from "./W05F0012_actions";

const initialState = {
    decimalQuantity: {},
};

export default function (state = initialState, action = {}) {
    switch (action.type) {
        case types.W05F0012_GET_DECIMAL_QUANTITY_SUCCESS:
            return { ...state, decimalQuantity: action.data };
        default:
            return state;
    }
}
